import React from 'react'
import { Typography } from '@mui/material'
import classes from './Heading6.module.css'

const Heading6 = (props) => {
  return (    
    <Typography
      className={classes.heading6}
      mt={props.marginTop || 2}
      component="h6"
      sx={{ color: "#242424", fontSize: '18px', ...props.sx }}
    >
      {props.text}
    </Typography>
  )
}

export default Heading6